import { useMutation } from '@tanstack/react-query'
import useSupabase from './use-supabase'

interface Credentials {
  email: string
  password: string
}

/**
 * @name useSignInWithEmailPassword
 */
function useSignInWithEmailPassword() {
  const client = useSupabase()

  const mutationFn = async (credentials: Credentials) => {
    return client.auth.signInWithPassword(credentials).then((response) => {
      if (response.error) {
        throw response.error
      }

      return response.data
    })
  }

  return useMutation({
    mutationFn,
  })
}

export default useSignInWithEmailPassword
